<template>
  <div id="app">
    <mobile-header />
    <layout-header />
    <layout-body></layout-body>
    <layout-footer />
    <mgtv-pc-login />
  </div>
</template>

<script>
import LayoutBody from "./components/layout-body.vue";
import LayoutFooter from "./components/layout-footer.vue";
import layoutHeader from "./components/layout-header.vue";
import MgtvPcLogin from "./components/mgtv-pc-login.vue";
import MobileHeader from "./components/mobile-header.vue";

export default {
  components: {
    layoutHeader,
    LayoutFooter,
    LayoutBody,
    MgtvPcLogin,
    MobileHeader,
  },

  mounted() {
    console.log("App Launch");
  },
};
</script>

<style lang="less">
body {
  font-family: 14px/1.5 PingFangSC-Regular, Arial, Microsoft Yahei, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: @black;
  // ios禁用字体跟随系统变化
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
}

* {
  margin: 0;
  padding: 0;
}
</style>
